interface Props {
  activeColor: string;
}

const ErnieeSuggestionIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="ernieeGradient"
          x1="24"
          y1="20"
          x2="104"
          y2="108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B5CF6" />
          <stop offset="0.5" stopColor="#06B6D4" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>

        <linearGradient
          id="brainGradient"
          x1="40"
          y1="34"
          x2="88"
          y2="86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A78BFA" />
          <stop offset="0.5" stopColor="#22D3EE" />
          <stop offset="1" stopColor="#4ADE80" />
        </linearGradient>

        <linearGradient
          id="sparkGradient"
          x1="64"
          y1="24"
          x2="64"
          y2="46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FACC15" />
          <stop offset="1" stopColor="#22D3EE" />
        </linearGradient>

        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect x="12" y="12" width="104" height="104" rx="28" fill="#0B1220" />
      <rect
        x="12"
        y="12"
        width="104"
        height="104"
        rx="28"
        stroke="url(#ernieeGradient)"
        strokeWidth="2"
        opacity="0.5"
      />

      <circle
        cx="64"
        cy="64"
        r="38"
        stroke="url(#ernieeGradient)"
        strokeWidth="2"
        opacity="0.18"
      />

      <path
        d="M50 45C50 38 55 33 62 33C66 33 69.5 35 71.8 38C73 37.5 74.3 37 76 37C81 37 85 41 85 46C85 47.5 84.6 48.9 84 50C87.5 52.2 90 56 90 60.5C90 65.5 87 69.8 82.8 71.5C83.2 72.5 83.5 73.8 83.5 75C83.5 80 79.5 84 74.5 84H58C51 84 46 79 46 72C46 69.5 47 67.2 48.5 65.5C45 63.5 43 60 43 56C43 50.5 46.5 46 50 45Z"
        stroke="url(#brainGradient)"
        strokeWidth="4"
        strokeLinejoin="round"
        filter="url(#glow)"
      />

      <path
        d="M64 22L67 30L76 31L69 36L71 44L64 39L57 44L59 36L52 31L61 30L64 22Z"
        fill="url(#sparkGradient)"
        filter="url(#glow)"
      />

      <path
        d="M52 92H76M76 92L68 84M76 92L68 100"
        stroke="#22D3EE"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#glow)"
      />

      <circle cx="48" cy="58" r="3.5" fill="#A78BFA" />
      <circle cx="78" cy="54" r="3.5" fill="#22D3EE" />
      <circle cx="70" cy="70" r="3.5" fill="#4ADE80" />

      <path
        d="M52 58H66"
        stroke="#A78BFA"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M74 56L70 66"
        stroke="#22D3EE"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ErnieeSuggestionIcon;
